import LeftMenu from "./LeftMenu";

export default function PageShell({ children }) {
  return (
    <div style={{display:"grid", gridTemplateColumns:"250px 1fr"}}>
      <LeftMenu />
      <div style={{minHeight:"100vh", background:"#f6f7fb"}}>{children}</div>
    </div>
  );
}
